/*
  generates an object to provide all common attributes to analytics
  ```
  {
    page: {
      browse_category: undefined,
      platform: undefined,
      path: '/ecom/shop/search', // extract from url
      previous_path: '/ecom/shop/groceries', // extract from redux/midleware/router/index.js
      site_section: undefined,
      type: 'page-type', // extract from url
    },
  }
  ```
 */
import root from 'window-or-global';

import pageUnloadEvent from 'constants/page-unload-event';
import { ORDER_CONFIRMATION } from 'constants/pageTypes';
import urls from 'constants/urls';
import env from 'env/env';
import { getPageTitle } from 'redux/middleware/analytics/actions-to-track/page/get-page-title';
import {
  getLocation,
  getPathname,
  getPreviousPath,
  getRoutingPageType,
} from 'redux/modules/routing/selectors';
import amendingOrder from 'redux/modules/trolley/selectors/amending-order';
import locator from 'utils/locator';
import { getExtraVirtualPageViewData } from '../order/place-order';

export const categoryLevels = [1, 2, 3, 4, 5, 6].map(pos => `category_level_${pos}`);

export default function transform(state) {
  const { search } = getLocation(state);
  const searchFiltered = search && search.match(/sortBy/) !== null;

  if (searchFiltered) {
    return null;
  }

  const completePreviousPath = getPreviousPath(state);
  let previousPath = completePreviousPath;

  if (completePreviousPath?.indexOf(urls.search) >= 0) {
    previousPath = completePreviousPath?.split('?')?.[0];
  }

  if (!previousPath && root?.document?.referrer) {
    previousPath = new URL(root.document.referrer, env.clientHost).pathname;
  }

  const type = getRoutingPageType(state);

  // *** Verify changes to extraData with Checkout team first! ***
  // It is used to send order information on the order-confirmation page after checkout.
  // This ensures that the analytics system receives the necessary order details for
  // reporting and analysis in client side tags.
  const extraData = type === ORDER_CONFIRMATION ? getExtraVirtualPageViewData() : {};

  const virtualPageViewEvent = {
    event: 'virtual_page_view',
    page: {
      location: locator.href,
      path: getPathname(state),
      previous_path: previousPath,
      title: getPageTitle(state),
      type,
      purchase_or_amend: amendingOrder(state) ? 'amend' : 'purchase',
    },
    // *** Verify changes to extraData with Checkout team first! ***
    ...extraData,
  };

  return completePreviousPath ? [pageUnloadEvent, virtualPageViewEvent] : virtualPageViewEvent;
}
